import {
    changeGoalMastery,
    changeSingleTargetMastery,
    changeTargetMastery,
    createGoal,
    createOption,
    createTarget,
    createSectionType,
    deleteGoal,
    restoreGoal,
    cloneGoal,
    upsertSectionDescriptionBlock,
    deleteSectionDescriptionBlock,
    reorderSectionDescriptionBlocks,
    deleteOption,
    restoreOption,
    editGoal,
    editGoalStatus,
    editOption,
    editSectionType,
    editTarget,
    deleteTarget,
    restoreTarget,
    editTargetTransitionDate,
    getGoalById,
    getSectionTypes,
    getGoalGraph,
    getGoals,
    getGoalSessions,
    getGoalsForSession,
    chooseGoalsFromLibrary,
    chooseTargetsFromLibrary,
    chooseOptionsFromLibrary,
    getTargetChartData,
    removeSingleTargetMastery,
    reorderOption,
    reorderTarget,
    getGoalTrialData,
    changeTargetMaintenance,
    addTargetMaintenanceStep,
    editTargetMaintenanceStep,
    deleteTargetMaintenanceStep,
    changeSingleTargetMaintenance,
    addSingleTargetMaintenanceStep,
    editSingleTargetMaintenanceStep,
    deleteSingleTargetMaintenanceStep,
    singleTargetFollowGoalConfig,
    singleTargetMasteryFollowGoal,
    changeBaselineCriteria,
    changeSingleTargetBaselineCriteria,
    singleTargetBaselineFollowGoal,
    removeSingleTargetBaselineCriteria,
    changeMaintenanceStep,
    getSimpleGoals,
    getGoalClinicalData,
    getGoalClinicalDefaultValues,
    getGoalTargetClinicalData,
} from './goal.action';
export { goalReducer } from './goal.reducer';
export { watchGoals } from './goal.saga';

export const goalActions = {
    /** Goals */
    getGoals,
    getGoalsForSession,
    getSimpleGoals,
    chooseGoalsFromLibrary,
    chooseTargetsFromLibrary,
    chooseOptionsFromLibrary,
    getGoalById,
    getSectionTypes,
    createSectionType,
    editSectionType,
    createGoal,
    editGoal,
    upsertSectionDescriptionBlock,
    deleteSectionDescriptionBlock,
    reorderSectionDescriptionBlocks,
    editGoalStatus,
    deleteGoal,
    restoreGoal,
    cloneGoal,
    getGoalSessions,
    getGoalGraph,
    getGoalTrialData,
    /** End */

    /** Targets */
    createTarget,
    editTarget,
    deleteTarget,
    restoreTarget,
    editTargetTransitionDate,
    reorderTarget,
    getTargetChartData,
    /** End */

    /** Options */
    createOption,
    editOption,
    reorderOption,
    deleteOption,
    restoreOption,
    /** End */

    /** Mastery */
    changeTargetMastery,
    changeGoalMastery,
    changeSingleTargetMastery,
    singleTargetMasteryFollowGoal,
    removeSingleTargetMastery,
    /** End */

    /** Baseline -> Teaching criteria */
    changeBaselineCriteria,
    changeSingleTargetBaselineCriteria,
    singleTargetBaselineFollowGoal,
    removeSingleTargetBaselineCriteria,
    /** End */

    changeSingleTargetMaintenance,
    addSingleTargetMaintenanceStep,
    editSingleTargetMaintenanceStep,
    singleTargetFollowGoalConfig,
    deleteSingleTargetMaintenanceStep,
    changeMaintenanceStep,
    /** End */

    /** Target Maintenance */
    changeTargetMaintenance,
    addTargetMaintenanceStep,
    editTargetMaintenanceStep,
    deleteTargetMaintenanceStep,
    /** End */

    /** Goal Clinical Data */
    getGoalClinicalData,
    getGoalTargetClinicalData,
    getGoalClinicalDefaultValues,
    /** End */
};
